import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'create-interaction-string-field',
  templateUrl: './string-field.component.html',
  styleUrls: ['./string-field.component.css'],
  standalone: false
})
export class StringFieldComponent {
  @Input() formParent: UntypedFormGroup
  constructor() { }
}
